export default __webpack_public_path__ + "static/media/body-gradient-bg.5f7aa1cd.jpg";